var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bounding_box",
    "data-name": "Bounding box"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.573,6.9082a6.51332,6.51332,0,0,0-3.98828-4.1289,8.17521,8.17521,0,0,0-5.17578,0A6.51516,6.51516,0,0,0,5.42261,6.9082a6.86084,6.86084,0,0,0,.56055,5.96192l6.01465,8.5039,6.03906-8.54A6.84925,6.84925,0,0,0,18.573,6.9082Zm-2.19336,4.80762-4.38183,6.19531L7.64039,11.752A4.91294,4.91294,0,0,1,7.3103,7.56836a4.533,4.533,0,0,1,2.73927-2.89453,6.15018,6.15018,0,0,1,3.89453,0,4.531,4.531,0,0,1,2.7412,2.89453A4.907,4.907,0,0,1,16.37964,11.71582ZM12,6.3574a3,3,0,1,0,3,3A3.00328,3.00328,0,0,0,12,6.3574Zm-.00219,4.25a1.25,1.25,0,1,1,1.25-1.25A1.25084,1.25084,0,0,1,11.99781,10.60742Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.5c0b2e9b10a10a2fcd14a982be76b583.svg";
export { ForwardRef as ReactComponent };